import { render, staticRenderFns } from "./RegisterInfoModal.vue?vue&type=template&id=223dc603&scoped=true&"
import script from "./RegisterInfoModal.vue?vue&type=script&lang=js&"
export * from "./RegisterInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./RegisterInfoModal.vue?vue&type=style&index=0&id=223dc603&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223dc603",
  null
  
)

export default component.exports